import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

import { onResponseUpdateEmployeePermissions } from "./helpers";

export const updateEmployeePermissions = async (
  data: UpdateEmployeePermissionsReqT
) => axios.post(Routes.UPDATE_EMPLOYEE_PERMISSIONS, data);

export const useUpdateEmployeePermissions = () =>
  useMutation({
    mutationKey: [Keys.UPDATE_EMPLOYEE],
    mutationFn: updateEmployeePermissions,
    onSettled: onResponseUpdateEmployeePermissions,
    cacheTime: Infinity,
  });
